// extracted by mini-css-extract-plugin
var _1 = "#4c4c4c";
var _2 = "cta_buttonwrapper__exbpe";
var _3 = "cta_content__chs+r";
var _4 = "640px";
var _5 = "790px";
var _6 = "#057676";
var _7 = "cta_hasheadline__sdkzq";
var _8 = "cta_headline__46exl";
var _9 = "cta_item__paqyc";
var _a = "79px";
var _b = "110px";
var _c = "72px";
var _d = "665px";
var _e = "cta_single__rcqh8";
var _f = "teal";
var _10 = "cta_text__gh0sq";
var _11 = "2";
var _12 = "#cdd3dc";
var _13 = "cta_wrapper__stwxz";
export { _1 as "body", _2 as "buttonWrapper", _3 as "content", _4 as "controlsMobileWidth", _5 as "controlsStackedWidth", _6 as "darkTeal", _7 as "hasHeadline", _8 as "headline", _9 as "item", _a as "menuHeight", _b as "menuHeightLarge", _c as "menuHeightMobile", _d as "modalMobileWidth", _e as "single", _f as "teal", _10 as "text", _11 as "timelineStrokeWidth", _12 as "timelineTrackColor", _13 as "wrapper" }
